// Frans (fr-FR), kamers: zelfde vorm als kamers.nl.ts. Tu-vorm, korte zinnen; kioskteksten in
// eenvoudige woorden voor kinderen.
export const kamersFr = {
    nav: {
        rooms: 'Pièces',
        cleaning: 'Ménage',
        kidLock: 'Verrou enfant',
    },
    roomKind: {
        living: 'Salon',
        bedroom: 'Chambre',
        utility: 'Buanderie ou placard',
    },
    rooms: {
        title: 'Pièces',
        intro: 'Chaque tablette appartient à une pièce. La pièce décide qui on voit sur la tablette.',
        add: 'Pièce',
        addTitle: 'Nouvelle pièce',
        everyone: 'Tout le monde',
        tablets: { one: '{count} tablette', other: '{count} tablettes' },
        noTablet: 'Pas encore de tablette',
        modeAgenda: 'Agenda et tâches',
        modeLogboek: 'Placard à ménage',
        open: 'Ouvrir',
        back: 'Pièces',
        name: 'Nom',
        nameHint: 'Par exemple : Chambre de Léo et Hugo',
        kind: 'Type de pièce',
        whoTitle: 'Qui voit-on sur cette tablette ?',
        whoIntro: 'Sur la tablette d’une chambre, on ne voit que les personnes qui y dorment.',
        whoAll: 'Tout le monde',
        whoExplicit: 'Seulement les occupants',
        residents: 'Occupants',
        residentsHint: 'Touche un visage pour l’ajouter ou le retirer.',
        noResidentsWarning: 'Choisis qui dort ici, sinon la tablette reste vide.',
        noResidentsUtility: 'Sans occupants, chacun peut se choisir sur cette tablette.',
        householdWide: 'Afficher aussi les événements de toute la famille',
        showTitle: 'Qu’affiche la tablette ?',
        showAgenda: 'Agenda et tâches',
        showAgendaHint: 'Le tableau habituel avec aujourd’hui, la semaine et les tâches.',
        showLogboek: 'Placard à ménage',
        showLogboekHint: 'Grandes tuiles : qui a fait la lessive, qui a passé l’aspirateur.',
        a11yTitle: 'Accessibilité sur la tablette',
        readAloud: 'Lire à voix haute',
        readAloudHint: 'Touche une image et la tablette la lit à voix haute. Pratique pour ceux qui ne savent pas encore lire.',
        textSize: 'Taille du texte',
        textNormal: 'Normale',
        textLarge: 'Grande',
        textFar: 'Très grande',
        calmMotion: 'Mouvements calmes',
        calmMotionHint: 'Pas d’animations de fête, tout apparaît en douceur.',
        sounds: 'Son',
        tabletsTitle: 'Tablettes dans cette pièce',
        tabletsEmpty: 'Il n’y a pas encore de tablette ici.',
        moveHere: 'Déplacer une tablette ici',
        moveChoose: 'Choisis une tablette',
        moved: '{name} est maintenant dans {room}.',
        lastSeen: 'vue {ago}',
        save: 'Enregistrer',
        saved: 'Enregistré. La tablette l’affiche d’ici une minute.',
        created: '{name} a été ajoutée.',
        remove: 'Supprimer la pièce',
        removeBlocked: 'Déplace d’abord la tablette dans une autre pièce.',
        removeTitle: 'Supprimer la pièce ?',
        removeBody: '{name} disparaît. L’historique est conservé.',
        removeConfirm: 'Supprimer',
        removed: '{name} a été supprimée.',
        lastRoom: 'Un foyer garde au moins une pièce.',
        conflict: 'Quelqu’un d’autre a modifié cette pièce entre-temps. Nous avons chargé la dernière version.',
        emptyTitle: 'Chaque pièce son tableau',
        emptyBody: 'Installe une tablette dans la chambre ou la buanderie et choisis qui on y voit.',
        notFound: 'Cette pièce n’existe pas (ou plus).',
    },
    cleaning: {
        title: 'Ménage',
        add: 'Tâche',
        tabTurn: 'À qui le tour',
        tabHistory: 'Historique',
        tabItems: 'Tâches',
        turnIntro: 'C’est au tour de celui qui n’a pas fait la tâche depuis le plus longtemps.',
        status: { fresh: 'Tout juste fait', soon: 'Bientôt', due: 'À refaire' },
        every: { one: 'tous les jours', other: 'tous les {count} jours' },
        everyWeek: 'chaque semaine',
        every2Weeks: 'toutes les 2 semaines',
        everyMonth: 'chaque mois',
        lastBy: 'Dernière fois : {name}, {when}',
        never: 'Jamais fait',
        turn: 'C’est son tour',
        doneAction: 'Fait…',
        doneTitle: '{item} fait',
        who: 'Qui',
        when: 'Quand',
        time: 'Heure',
        whenHint: 'Tu peux remonter jusqu’à 30 jours.',
        note: 'Note',
        logged: '{item} : fait par {name}.',
        loggedNoPoints: 'Enregistré. Pas de points : {name} l’avait déjà fait {when}.',
        points: { one: '{count} étoile', other: '{count} étoiles' },
        alreadyBy: 'déjà fait par {name}',
        deleted: 'supprimé',
        source: { kiosk: 'sur la tablette', app: 'dans l’appli' },
        removeLog: 'Supprimer',
        removeLogTitle: 'Supprimer cette fois-ci ?',
        removeLogBody: '{name} ne reçoit plus les points.',
        removeLogConfirm: 'Supprimer',
        logRemoved: 'Supprimé.',
        negativeTitle: 'Le solde devient négatif',
        negativeBody: '{name} a déjà dépensé les points. Supprimer quand même ?',
        historyEmptyTitle: 'Rien de fait pour l’instant',
        historyEmptyBody: 'Dès que quelqu’un note une tâche, tu la vois ici.',
        filterAll: 'Tout le monde',
        filterLabel: 'Filtrer par membre',
        showDeleted: 'Afficher aussi les suppressions',
        today: 'Aujourd’hui',
        yesterday: 'Hier',
        itemsIntro: 'Par endroit, les tâches et leur fréquence.',
        noLocation: 'Sans endroit',
        edit: 'Modifier',
        archive: 'Retirer',
        archived: '{name} a été retiré.',
        editorNew: 'Nouvelle tâche',
        editorEdit: 'Modifier la tâche',
        itemName: 'Nom',
        itemNameHint: 'Court et clair, par exemple : Lancer la machine',
        icon: 'Pictogramme',
        location: 'Endroit',
        newLocation: 'Nouvel endroit…',
        newLocationName: 'Nom de l’endroit',
        howOften: 'À quelle fréquence',
        customDays: 'Nombre de jours',
        pointsLabel: 'Points',
        pointsHint: 'Une fois au maximum par période, même si plusieurs personnes le font.',
        participants: 'Qui participe',
        participantsHint: 'Personne de choisi = tout le monde.',
        saved: 'Enregistré.',
        conflict: 'Cette tâche a été modifiée entre-temps. Nous avons chargé la dernière version.',
        emptyTitle: 'Pas encore de tâches de ménage',
        emptyBody: 'Commence par quelque chose qui revient souvent, comme la machine à laver.',
        emptyAction: 'Ajouter une tâche',
        suggestions: 'Ou commence avec un exemple',
        suggest: {
            laundry: 'Lancer la machine',
            hang: 'Étendre le linge',
            bath: 'Nettoyer la salle de bain',
            vacuum: 'Passer l’aspirateur',
            plants: 'Arroser les plantes',
        },
        loadError: 'Un problème est survenu. Réessaie.',
        retry: 'Réessayer',
    },
    kidLock: {
        title: 'Verrou enfant',
        intro: 'Pratique quand les frères et sœurs cochent les tâches des autres. Désactivé par défaut ; le verrou ne s’applique que sur la tablette.',
        none: 'Pas de verrou',
        pin: 'Code PIN',
        picture: 'Code en images',
        since: 'depuis {when}',
        waiting: 'attend jusqu’à {time}',
        set: 'Configurer',
        change: 'Modifier',
        sheetTitle: 'Verrou enfant pour {name}',
        kindLabel: 'Type de verrou',
        noneHint: 'Sur la tablette, tout le monde peut cocher pour {name}.',
        pinHint: '4 chiffres dont {name} se souvient.',
        pictureHint: '4 images dans l’ordre. Laisse {name} les choisir.',
        pinLabel: 'Code PIN (4 chiffres)',
        pinRepeat: 'Encore une fois',
        pinMismatch: 'Les deux codes PIN ne sont pas identiques.',
        pinInvalid: 'Choisis exactement 4 chiffres.',
        pictureChosen: 'Choisies : {count} sur 4',
        pictureClear: 'Effacer',
        pictureInvalid: 'Choisis 4 images.',
        pictureSlot: 'Image {n}',
        saved: 'Le verrou enfant de {name} a été modifié.',
        removed: 'Le verrou enfant de {name} est désactivé.',
        emptyTitle: 'Pas encore d’enfants',
        emptyBody: 'Ajoute d’abord tes enfants dans Membres.',
        about: 'Oublié ? Choisis ici un nouveau code. Cinq erreurs sur la tablette, et il faut attendre un peu.',
    },
    picture: {
        fox: 'Renard',
        cat: 'Chat',
        rabbit: 'Lapin',
        bear: 'Ours',
        panda: 'Panda',
        owl: 'Hibou',
        lion: 'Lion',
        frog: 'Grenouille',
        turtle: 'Tortue',
    },
    voice: {
        dictate: 'Dicter',
        listening: 'J’écoute…',
        stop: 'Arrêter',
        heard: 'Compris : {text}',
        failed: 'Je n’ai pas compris. Écris-le plutôt.',
    },
    kiosk: {
        entry: 'Ménage',
        title: 'Placard à ménage',
        back: 'Retour',
        who: 'Qui l’a fait ?',
        hold: 'Garde le doigt sur ton visage jusqu’à ce que le cercle soit plein',
        holdShort: 'Garde le doigt',
        status: { fresh: 'Tout juste fait', soon: 'Bientôt', due: 'À refaire' },
        never: 'jamais',
        justNow: 'à l’instant',
        minutesAgo: { one: '{count} min', other: '{count} min' },
        hoursAgo: { one: '{count} h', other: '{count} h' },
        daysAgo: { one: '{count} jour', other: '{count} jours' },
        goodJob: 'Bravo, {name} !',
        /** Rustig, buiten het thema Kinderen (geen lof, geen sterren). */
        goodJobCalm: 'Fait par {name}',
        stars: { one: '+{count} étoile', other: '+{count} étoiles' },
        alreadyDone: 'Déjà fait par {name} à {time}. Merci quand même !',
        alreadyDoneCalm: 'Déjà fait par {name} à {time}.',
        oops: 'Oups',
        undone: 'C’est retiré',
        other: 'Autre…',
        otherTitle: 'Qu’est-ce que tu as fait ?',
        sayIt: 'Dis-le',
        emptyTitle: 'Pas encore de tâches',
        emptyBody: 'Papa ou maman les prépare dans l’appli.',
        notSaved: 'Pas encore enregistré, on réessaie dans un instant.',
        close: 'Fermer',
        lockAskPin: '{name}, quel est ton code ?',
        lockAskPicture: '{name}, quelles images ?',
        lockWrong: 'Encore une fois',
        lockWait: 'Attends un peu…',
        lockDigit: 'Chiffre {digit}',
        lockErase: 'Effacer',
        lockProgress: '{count} sur 4',
        adhoc: {
            windows: 'Laver les vitres',
            sweep: 'Balayer',
            trash: 'Sortir la poubelle',
            dishes: 'Vaisselle',
            'tidy-up': 'Ranger',
            'water-plants': 'Arroser',
            recycling: 'Verre et papier',
            'make-bed': 'Changer les draps',
        },
    },
    speech: {
        at: 'à {time}',
        points: { one: '{count} étoile', other: '{count} étoiles' },
    },
    a11y: {
        skipToContent: 'Aller au contenu',
        mainNav: 'Navigation principale',
    },
};
//# sourceMappingURL=kamers.fr.js.map